import styled from "styled-components";

import { MultiLineText } from "./MultiLineText";

export const MapAreaText = styled(MultiLineText)`
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
  max-height: calc(1.2em * 2);
  word-break: break-word;
`;
